import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    palette: {
        primary: {
            contrastText: "#fff",
            dark: "#b5005a",
            light: "#ff6fb8",
            main: "#ed3587"
        },
        secondary: {
            contrastText: "#fff",
            dark: "#52928F",
            light: "#82c3bf",
            main: "#464BA1",
        }
    },
    components: {
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '@media (pointer: coarse)': {
                        '&:hover': {
                            background: "transparent",
                        }
                    }
                },
            },
        },
        PrivatePickersMonth: {
            styleOverrides: {
                root: {
                    '@media (pointer: coarse)': {
                        '&:hover': {
                            background: "transparent",
                        }
                    }
                },
            },
        },
        PrivatePickersYear: {
            styleOverrides: {
                button: {
                    '@media (pointer: coarse)': {
                        '&:hover': {
                            background: "transparent",
                        }
                    }
                }
            }
        }
    },
});

export default theme;